export enum EntityType {
  PolicyStatus = 'PolicyStatus',
  RoomType = 'RoomType',
  SBSCode = 'SbsCode',
  Category = 'Category',
  ContractStatus = 'ContractStatus',
  BloodGroup = 'BloodGroup',
  PreferredLanguage = 'PreferredLanguage',
  VisaType = 'VisaType',
  PatientShareType = 'PatientShareType',
  RoutesOfAdministration = 'RoutesOfAdministration',
  CaseType = 'CaseType',
  DosageForm = 'DosageForm',
  PackageType = 'PackageType',
  UnitType = 'UnitType',
  StandardName = 'StandardName',
  Country = 'Country',
  State = 'State',
  City = 'City'
}

export enum ExportKey {
  PolicyStatus = 'PolicyStatus',
  RoomType = 'RoomType',
  SBSCode = 'SbsCode',
  Category = 'Category',
  ContractStatus = 'ContractStatus',
  BloodGroup = 'BloodGroup',
  VisaType = 'VisaType',
  PatientShareType = 'PatientShareType',
  CaseType = 'CaseType',
  Country = 'Country',
  State = 'State',
  City = 'City',
  PriceList = "PriceList",
  Beneficiary = "Beneficiary",
  Provider = "Provider",
  SubCoverage = "SubCoverage",
  InsuranceCompany = "InsuranceCompany",
  Network = "Network",
  Benefit = "Benefit",
  RoutesOfAdministration = "RoutesOfAdministration",
  DosageForm = "DosageForm",
  PackageType = "PackageType",
  UnitType = "UnitType",
  PolicyClass = "PolicyClass",
  StandardName = "StandardName",
  ServiceCode = "ServiceCode",
  ServiceType = "ServiceType",
  PreferredLanguage = "PreferredLanguage",
  LoincCode = "LoincCode",
  EncounterClass = 'EncounterClass'
}